import {removeLoadingState, setVisibility} from "../helpers";
import {downloadDocument} from "../../features";

export function initDocumentDownloads(){
    
    const buttons = document.querySelectorAll('[data-download]');
    buttons.forEach(element => {
        element.addEventListener('click', handleDownload);
    });

    const serverErrorContainer = document.getElementById("downloadNotification-500");
    const httpErrorContainer = document.getElementById("downloadNotification-404");
    
    function handleDownload(event) {
        
        event.preventDefault();
        
        setVisibility(serverErrorContainer, false);
        setVisibility(httpErrorContainer, false);

        const button = event.currentTarget;

        const targetElement = event.currentTarget;
        const fileLocation = targetElement.getAttribute('href');
        const fileName = targetElement.dataset.filename;

        return downloadDocument(fileLocation, fileName).catch(handleErrorResponse).finally(()=>{
            removeLoadingState(button);
        });
    }

    function handleErrorResponse(error) {
        
        if(/\(500\)/.test(error.message)) {
            setVisibility(serverErrorContainer, true);
        }else{
            setVisibility(httpErrorContainer, true);
        }
    }
}